"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _state = require("@seedlang/state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ReportBugWrapper = function ReportBugWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "message", _descriptor, _this);
      _initializerDefineProperty(_this, "email", _descriptor2, _this);
      _initializerDefineProperty(_this, "image", _descriptor3, _this);
      _initializerDefineProperty(_this, "displaySubmittedMessage", _descriptor4, _this);
      _initializerDefineProperty(_this, "submitting", _descriptor5, _this);
      _this.onSubmit = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(params) {
          var debugInfo, imageUrl, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                if (_this.disabled) {
                  _context.n = 7;
                  break;
                }
                _this.submitting = true;
                console.log('onSubmit called, image:', _this.image);
                debugInfo = _objectSpread(_objectSpread({}, _state.DeckUI.debugInfo), {}, {
                  bugType: params.bugType,
                  timestamp: new Date().toISOString(),
                  appVersion: params.mobileVersion || params.webVersion,
                  platform: params.deviceType,
                  dimensions: params.dimensions
                });
                imageUrl = null; // If there's an image, upload it first
                if (!(_this.image && _this.image.formData)) {
                  _context.n = 5;
                  break;
                }
                console.log('Image found, uploading...');
                _context.p = 1;
                _context.n = 2;
                return _this.uploadImage(_this.image.formData);
              case 2:
                imageUrl = _context.v;
                console.log('Image uploaded successfully, URL:', imageUrl);
                _context.n = 4;
                break;
              case 3:
                _context.p = 3;
                _t = _context.v;
                console.error('Failed to upload image:', _t);
                _this.submitting = false;
                return _context.a(2);
              case 4:
                _context.n = 6;
                break;
              case 5:
                if (_this.image && _this.image.url) {
                  console.log('Image found, using URL...');
                  imageUrl = _this.image.url;
                } else {
                  console.log('No image to upload');
                }
              case 6:
                console.log('Creating contact message with image_url:', imageUrl);
                _state.AppUI.contactMessageStore.create({
                  data: {
                    webVersion: params.webVersion,
                    mobileVersion: params.mobileVersion,
                    deviceType: params.deviceType,
                    deviceLanguageId: _state.AppUI.targetLanguageId,
                    message: _this.message,
                    email: (0, _utils.isPresent)(_this.email) ? _this.email : _state.AppUI.user.email,
                    debug_info: debugInfo,
                    image_url: imageUrl,
                    logs: params.logs
                  }
                }, _this.afterSubmit);
              case 7:
                return _context.a(2);
            }
          }, _callee, null, [[1, 3]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
      _this.uploadImage = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(formData) {
          var _require, Api, _require2, RootLayout, layout, url, baseUrl, response, data;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _require = require('@seedlang/stores'), Api = _require.Api;
                _require2 = require('@seedlang/layouts'), RootLayout = _require2.RootLayout;
                layout = new RootLayout(); // Use the same URL building logic as Api.js
                url = '/api/contact_messages/upload_image';
                if (layout.isNative && __DEV__) {
                  baseUrl = Api.devApiPath || 'https://www.seedlang.com';
                  url = "".concat(baseUrl).concat(url);
                  console.log('Mobile dev upload URL:', url);
                } else if (layout.isNative) {
                  url = "https://www.seedlang.com".concat(url);
                  console.log('Mobile prod upload URL:', url);
                } else {
                  console.log('Web upload URL:', url);
                }
                console.log('Uploading image...');
                _context2.n = 1;
                return fetch(url, {
                  method: 'POST',
                  headers: {
                    'Accept': 'application/json',
                    'Authorization': Api.jwtToken || '',
                    'DEVICE': Api.nativeDevice || 'web'
                  },
                  body: formData
                });
              case 1:
                response = _context2.v;
                console.log('Upload response status:', response.status);
                _context2.n = 2;
                return response.json();
              case 2:
                data = _context2.v;
                console.log('Upload response data:', data);
                if (!(data.success && data.url)) {
                  _context2.n = 3;
                  break;
                }
                return _context2.a(2, data.url);
              case 3:
                throw new Error(data.error || 'Upload failed');
              case 4:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }();
      _this.onImageSelect = function (formData) {
        console.log('onImageSelect called');
        console.log('FormData:', formData);

        // Store the FormData and extract URI for preview
        var imagePart = formData._parts && formData._parts.find(function (part) {
          return part[0] === 'image';
        });
        console.log('Image part:', imagePart);
        var imageObject = imagePart && imagePart[1];
        console.log('Image object:', imageObject);
        if (imageObject && imageObject.uri) {
          var uploadFormData = new FormData();
          uploadFormData.append('blob', imageObject);
          _this.image = {
            formData: uploadFormData,
            uri: imageObject.uri
          };
          console.log('Image set to:', _this.image);

          // Close the image picker modal
          _state.AppUI.set('showImagePickerModal', false);
        } else {
          console.error('Failed to extract image object from FormData');
        }
      };
      _this.afterSubmit = function () {
        _this.onReset();
        _this.submitting = false;
        _this.displaySubmittedMessage = true;
        setTimeout(function () {
          return _this.displaySubmittedMessage = false;
        }, 5000);
      };
      _this.onReset = function () {
        _this.message = '';
        _this.image = null;
      };
      _this.setMessage = function (message) {
        _this.message = message;
      };
      _this.setImage = function (image) {
        _this.image = image;
      };
      _this.setEmail = function (email) {
        _this.email = email;
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "disabled",
      get: function get() {
        return (0, _utils.isBlank)(this.message) || this.requiresEmailAddress && !(0, _utils.isValidEmail)(this.email);
      }
    }, {
      key: "requiresEmailAddress",
      get: function get() {
        var _AppUI$user, _AppUI$user2;
        return !_state.AppUI.userIsLoaded || ((_AppUI$user = _state.AppUI.user) === null || _AppUI$user === void 0 || (_AppUI$user = _AppUI$user.email) === null || _AppUI$user === void 0 ? void 0 : _AppUI$user.match('privaterelay.appleid')) || ((_AppUI$user2 = _state.AppUI.user) === null || _AppUI$user2 === void 0 || (_AppUI$user2 = _AppUI$user2.email) === null || _AppUI$user2 === void 0 ? void 0 : _AppUI$user2.match('apple.com'));
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          message: this.message,
          setMessage: this.setMessage,
          requiresEmailAddress: this.requiresEmailAddress,
          disabled: this.disabled,
          onSubmit: this.onSubmit,
          onReset: this.onReset,
          image: this.image,
          setImage: this.setImage,
          onImageSelect: this.onImageSelect,
          setEmail: this.setEmail,
          email: this.email,
          submitting: this.submitting,
          displaySubmittedMessage: this.displaySubmittedMessage
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "message", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "email", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "image", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "displaySubmittedMessage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "submitting", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "disabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "disabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "requiresEmailAddress", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "requiresEmailAddress"), _class2.prototype), _class2)) || _class;
};
ReportBugWrapper.displayName = 'ReportBugWrapper';
var _default = exports["default"] = ReportBugWrapper;